import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as actionTypes from './actionTypes';

export const setURASearchLoading = (payload) => {
  return {
    type: actionTypes.URA_SEARCH_LOADING,
    payload,
  };
};

export const dispatchErrorMessages = (payload) => {
  return {
    type: actionTypes.SET_ERROR_MESSAGES,
    payload,
  };
};

export const dispatchSuccessMessages = (payload) => {
  return {
    type: actionTypes.SET_SUCCESS_MESSAGES,
    payload,
  };
};

export const setURASearchFormValues = (payload) => {
  return {
    type: actionTypes.SET_URA_SERCH_FORM_VALUES,
    payload,
  };
};

export const dispatchAllRebateProgramCode = (payload) => {
  return {
    type: actionTypes.GET_ALL_REBATE_PROGRAMS,
    payload,
  };
};

export const dispatchManufacturersData = (payload) => {
  return {
    type: actionTypes.GET_MANUFACTURER_LIST,
    payload,
  };
};

export const setURADetailsTableRowSelected = (payload) => {
  return {
    type: actionTypes.URA_DETAILS_TABLE_ROW_SELECTED,
    payload,
  };
};

export const setURADetailsTableData = (payload) => {
  return {
    type: actionTypes.GET_URA_DETAILS_TABLE_DATA,
    payload,
  };
};

export const setURASearchByDrugNameTableData = (payload) => {
  return {
    type: actionTypes.URA_SEARCH_BY_DRUG_NAME_TABLE_DATA,
    payload,
  };
};

export const setURALabelerDrugTableData = (payload) => {
  return {
    type: actionTypes.URA_LABELER_DRUG_TABLE_DATA,
    payload,
  };
};

export const setURALabelerTableData = (payload) => {
  return {
    type: actionTypes.URA_LABELER_TABLE_DATA,
    payload,
  };
};

export const setCalculatedURAHeaderDataList = (payload) => {
  return {
    type: actionTypes.SET_CALCULATED_URA_HEADER_DATA_LIST,
    payload,
  };
};

export const setCalculatedURAHeaderData = (payload) => {
  return {
    type: actionTypes.SET_CALCULATED_URA_HEADER_DATA,
    payload,
  };
};

export const setTopGridTableData = (payload) => {
  return {
    type: actionTypes.SET_TOP_GRID_TABLE_DATA,
    payload,
  };
};

export const setChildGridDetailList = (payload) => {
  return {
    type: actionTypes.SET_CHILD_GRID_DETAIL_LIST,
    payload,
  };
};

export const setGovGridNdcDetaliList = (payload) => {
  return {
    type: actionTypes.SET_GOV_GRID_NDC_DETAIL_LIST,
    payload,
  };
};

export const setCalculatedURAIndex = (payload) => {
  return {
    type: actionTypes.SET_CALCULATED_URA_INDEX,
    payload,
  };
};

export const setDrugFamilyTableData = (payload) => {
  return {
    type: actionTypes.SET_DRUG_FAMILY_TABLE_DATA,
    payload,
  };
};

export const setManufactuererSelectedRows = (payload) => {
  return {
    type: actionTypes.SET_MANUFACTURER_SELECTED_ROWS,
    payload,
  };
};

export const setDrugFamilySelectedRows = (payload) => {
  return {
    type: actionTypes.SET_DRUG_FAMILY_SELECTED_ROWS,
    payload,
  };
};

export const dispatchGetUserDefaults = (payload) => {
  return {
    type: actionTypes.GET_USER_DEFAULTS,
    payload,
  };
};

export const getRebateProgramCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: values })
    .then((response) => {
      return dispatch(dispatchAllRebateProgramCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllRebateProgramCode(response.date));
    });
};

export const getManufacturerListAndNdc = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_MANUFACTURER_LIST_AND_NDC}`, values)
    .then((response) => {
      return dispatch(dispatchManufacturersData(response.data));
    })
    .catch((response) => {
      dispatch(dispatchManufacturersData(response.data));
    });
};

export const getDrugFamily = (values) => (dispatch, getState) => {
  return axios
    .post(`${serviceEndPoint.GET_DRUG_FAMILY_BY_MFG_ID_IN_URA}`, values)
    .then((response) => {
      return dispatch(
        setDrugFamilyTableData(
          response.data?.map((item) => ({
            ...item,
            mfgId: values.mfgId,
          }))
        )
      );
    })
    .catch((response) => {});
};

export const getCalculatedData = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_CALCULATED_URA_DETAIL_HEADER}`, values)
    .then((response) => {
      dispatch(setCalculatedURAHeaderData(response.data?.[0]));
      dispatch(setCalculatedURAIndex(0));
      dispatch(setCalculatedURAHeaderDataList(response.data || []));
      return response.data;
    })
    .catch(({ response }) => {
      dispatch(setGetCalculatedURAError(response.data?.errorMessage));
      dispatch(setCalculatedURAHeaderData(null));
      dispatch(setCalculatedURAHeaderDataList([]));
      return response.data;
    });
};

export const getTopGridCalculatedURAData = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_CALCULATED_URA_TOP_GRID_DATA}`, values)
    .then((response) => {
      dispatch(setTopGridTableData(response.data));
      return response.data;
    })
    .catch((response) => {
      dispatch(setTopGridTableData(response.data));
    });
};

export const getChildGridDetailList = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_CHILD_GRID_DETAIL_LIST}`, values)
    .then((response) => {
      return dispatch(setChildGridDetailList(response.data));
    })
    .catch((response) => {
      dispatch(setChildGridDetailList(response.data));
    });
};

export const getGovGridNdcDetaliList = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_GOV_GRID_NDC_DETAIL_LIST}`, values)
    .then((response) => {
      return dispatch(
        setGovGridNdcDetaliList(
          response.data?.map((item) => {
            if (!item['ndc']) {
              item[
                'ndc'
              ] = `${item['labelerCode']}-${item['productCode']}-${item['packageSize']}`;
            }
            return item;
          })
        )
      );
    })
    .catch((response) => {
      dispatch(setGovGridNdcDetaliList([]));
    });
};

export const checkURAAndAddToDetailsTable = (data) => {
  return (dispatch, getState) => {
    dispatch(setURASearchLoading(true));
    const currentDetailsTableData = [
      ...getState().sharedState.URASearchReducer.URADetailsTableData,
    ];
    if (data.length === 1) {
      const index = currentDetailsTableData.findIndex(
        (item) => item.ndc === data[0].ndc
      );

      if (index === -1) {
        currentDetailsTableData.push({
          ndc: data[0].ndc,
          drugName: data[0].drugName,
          ...data[0],
        });

        dispatch(setURADetailsTableData(currentDetailsTableData));
      } else {
        dispatch(dispatchErrorMessages(['NDC already added']));
      }
    } else {
      data.forEach((ndcItem) => {
        const index = currentDetailsTableData.findIndex(
          (item) => item.ndc === ndcItem.ndc
        );

        if (index === -1) {
          currentDetailsTableData.push({
            ndc: ndcItem.ndc,
            drugName: ndcItem.drugName,
            ...ndcItem,
          });
        }
      });
      dispatch(setURADetailsTableData(currentDetailsTableData));
    }
    dispatch(setURASearchLoading(false));
  };
};

export const removeFromURADetailsTableData = () => {
  return (dispatch, getState) => {
    const currentDetailsTableData = [
      ...getState().sharedState.URASearchReducer.URADetailsTableData,
    ];
    const currentDetailsTableSelectedRow = [
      ...getState().sharedState.URASearchReducer.URADetailsTableRowSelected,
    ];

    if (currentDetailsTableData.length === 0) {
      dispatch(dispatchErrorMessages(['Nothing to remove.']));
    } else if (currentDetailsTableSelectedRow.length === 0) {
      dispatch(
        dispatchErrorMessages([
          'Please select a drug to remove from the selected list.',
        ])
      );
    } else {
      let updatedCurrentDetailsTableData = currentDetailsTableData.filter(
        (filterItem) =>
          currentDetailsTableSelectedRow.findIndex(
            (item) => item.ndc === filterItem.ndc
          ) === -1
      );

      dispatch(setURADetailsTableRowSelected([]));
      dispatch(dispatchErrorMessages([]));
      dispatch(setURADetailsTableData(updatedCurrentDetailsTableData));
    }
  };
};

export const setDefaultQtr = (data) => {
  return {
    type: actionTypes.SET_DEFAULT_QTR,
    payload: data,
  };
};

export const getMaxQuarterForFreezeDt = () => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_MAXQUARTER_FOR_FREEZE_DT}`)
    .then((response) => {
      return dispatch(setDefaultQtr(response.data));
    })
    .catch((response) => {
      dispatch(setDefaultQtr(response.date));
    });
};

export const setGetCalculatedURAError = (data) => {
  return {
    type: actionTypes.SET_CALCULATED_URA_ERROR,
    payload: data,
  };
};

export const resetURASearchStore = () => {
  return {
    type: actionTypes.RESET_URA_SEARCH_STORE,
  };
};

export const resetURADetailStore = () => {
  return {
    type: actionTypes.RESET_URA_DETAIL_STORE,
  };
};
